import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=179d2dc6&scoped=true"
import script from "./particulars.vue?vue&type=script&lang=js"
export * from "./particulars.vue?vue&type=script&lang=js"
import style0 from "./particulars.vue?vue&type=style&index=0&id=179d2dc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d2dc6",
  null
  
)

export default component.exports